import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash-es';
import { getSuggestions } from '@/lib/utilities/repository';
import useTranslation from 'next-translate/useTranslation';
import { Product } from '@/lib/types/bevmaq.types';
import LinkTranslated from '@/components/Translator/LinkTranslated';
import { AppState } from '@/app/store';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { setFormInUrl, setPage, setSearch } from './productsFilterSlice';
import { useRouter } from 'next/router';
export function SearchBar() {
  const searchValue = useAppSelector(
    (state: AppState) => state.productFilter.search
  );

  const dispatch = useAppDispatch();
  const [options, setOptions] = useState<Product[]>();
  const { t } = useTranslation();
  const { locale } = useRouter();
  const form = useAppSelector((state: AppState) => state.productFilter);
  const [searchBarText, setSearchBarText] = useState(searchValue);
  const debounceSetSearchQuery = useMemo(
    () =>
      debounce(async (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value ?? '';
        setSearchBarText(input);
        if (input) {
          const products = await getSuggestions(locale as string, input);
          setOptions(products.results);
        }
      }, 300),
    [locale]
  );
  useEffect(() => {
    setSearchBarText(searchValue);
  }, [searchValue]);
  return (
    <div className='relative max-w-xl flex-1 md:mr-4 lg:max-w-2xl'>
      <form
        action=''
        onSubmit={(e) => {
          e.preventDefault();
          setOptions([]);
          document.getElementById('searchbar')?.blur();
          dispatch(setPage(1));
          setFormInUrl({
            ...form,
            page: 1,
          });
          dispatch(setSearch(searchBarText));
        }}
      >
        <div className='sw-full border-custom-search flex items-center rounded border-orange-400 focus-within:shadow-3xl'>
          <label
            className='group btn btn-square max-h-10 min-h-0 w-10 cursor-default !rounded  border-0 bg-orange-100 hover:bg-orange-200 lg:max-h-12 lg:w-12'
            aria-label='search'
            htmlFor='searchbar'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6 text-slate-400 group-hover:text-white'
              fill='none'
              viewBox='0 0 24 24'
              stroke='#FB8E45'
              strokeWidth='2'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='{2}'
                d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
              />
            </svg>
          </label>

          <input
            id='searchbar'
            type='search'
            placeholder={t('common:Search') + '…'}
            className='peer input h-4 w-full border-0 py-0 outline-none ring-0 focus:border-0 focus:outline-none focus:ring-0'
            onChange={debounceSetSearchQuery}
            onBlur={() => setTimeout(() => setOptions([]), 150)}
            autoComplete='off'
          />
          {/* This button is only here for submitting the product filter when you press ENTER on the search bar */}

          <input type='submit' hidden />
        </div>
      </form>
      <ul className='absolute top-12 w-full'>
        {searchBarText &&
          options &&
          options.map((option) => (
            <LinkTranslated
              href={{
                pathname: '/buy/[slug]',
                query: { slug: option.slug },
              }}
              key={option.id}
            >
              <li className='w-full cursor-pointer border-2 bg-slate-100 p-2'>
                {option.model.name +
                  ' - ' +
                  option.model.manufacturer.name +
                  ' - ' +
                  option.year +
                  ' - ' +
                  option.country.name}
              </li>
            </LinkTranslated>
          ))}
      </ul>
    </div>
  );
}
